import { Brain, Code2, Eye, Globe2, Scale, Sparkles, Zap } from 'lucide-react';

export function ModelIcon({ alias, className = 'size-4' }: { alias: string; className?: string }) {
  const normalized = alias.toLowerCase();
  if (normalized.includes('fast')) return <Zap className={className} />;
  if (normalized.includes('balance')) return <Scale className={className} />;
  if (normalized.includes('power')) return <Brain className={className} />;
  if (normalized.includes('coding') || normalized.includes('code')) return <Code2 className={className} />;
  if (normalized.includes('multi') || normalized.includes('language')) return <Globe2 className={className} />;
  if (normalized.includes('vision')) return <Eye className={className} />;
  return <Sparkles className={className} />;
}
